import { connect } from 'react-redux'
import { InternetServiceComponent } from './InternetService'
import showCasesCreateTroubleTicket from 'features/Cases/CasesCreateTroubleTicket'
import showNumbersDisconnectModal from 'features/Numbers/NumbersDisconnectModal'

const stateToProps = () => ({})

export const dispatchToProps = {
  showCasesCreateTroubleTicket,
  showNumbersDisconnectModal,
}

export const InternetService = connect(stateToProps, dispatchToProps)(InternetServiceComponent)



// WEBPACK FOOTER //
// src/pages/InternetService/InternetService.container.ts